import ProductCard from '@/components/Helpers/ProductCard'
import React from 'react'

const CategoryProductsList = ({products, t}) => {
  return (
    <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4'>
      {products?.map(({_source: product }) => <ProductCard key={product.sku} product={product} t={t} />)}
    </div>
  )
}

export default React.memo(CategoryProductsList)